.detail-page {
  --content-max: 1500px;
  --container-pad: clamp(16px, 4vw, 48px);
  --tap-min: 44px;

  .page {
    width: 100%;
    min-height: 100%;
    background-color: #fff;
  }

  .detail-header {
    width: 100%;
  }

  .detail-main {
    width: min(var(--content-max), calc(100% - 2 * var(--container-pad)));
    margin: 0 auto;
    padding-top: clamp(24px, 6vw, 72px);
  }

  .product-overview {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
    gap: clamp(28px, 4vw, 64px);
    align-items: start;
  }

  .product-overview__gallery {
    width: 100%;
    min-width: 0;
  }

  .product-overview__collection {
    margin: 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(18px, 2vw, 28px);
    font-family: Red Rose-Regular;
    line-height: 1.2;
  }

  .product-overview__title {
    margin: clamp(10px, 1.8vw, 20px) 0 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(34px, 4.2vw, 60px);
    font-family: Red Rose-SemiBold;
    line-height: 1.05;
  }

  .product-overview__sku {
    margin: clamp(12px, 1.8vw, 24px) 0 0;
    color: rgba(22, 0, 4, 0.5);
    font-size: clamp(16px, 1.8vw, 24px);
    font-family: PingFang SC-Regular;
    line-height: 1.2;
  }

  .product-overview__description {
    margin: clamp(20px, 3vw, 50px) 0px;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(14px, 1.2vw, 18px);
    font-family: PingFang SC-Regular;
    line-height: 1.7;
    max-width: 66ch;
  }

  .product-overview__actions {
    margin-top: clamp(24px, 3vw, 44px);
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: min(100%, 330px);
  }

  .button-outline,
  .button-primary {
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: var(--tap-min);
    padding: 12px 16px;
    border-radius: 8px;
    font-size: clamp(16px, 1.3vw, 22px);
    font-family: Red Rose-Regular;
    line-height: 1.2;
    text-decoration: none;
    cursor: pointer;
  }

  .button-outline {
    border: 2px solid rgba(22, 0, 4, 1);
    background-color: transparent;
    color: rgba(22, 0, 4, 1);

    &:visited {
      color: rgba(22, 0, 4, 1);
    }
  }

  .button-primary {
    border: 1px solid rgba(22, 0, 4, 1);
    background-color: rgba(22, 0, 4, 1);
    color: #fff;

    &:visited {
      color: #fff;
    }
  }

  .attributes-section {
    margin-top: clamp(64px, 8vw, 120px);
    padding-top: clamp(24px, 3vw, 36px);
    border-top: 1px solid rgba(241, 241, 241, 1);
    /* Product Attributes: reveal as a single, faster block. */
    --motion-delay: 0ms;
    --motion-duration: 420ms;
    --motion-distance: 16px;
    --motion-scale-from: 0.992;
    --motion-tilt-from: 0deg;
  }

  .section-title {
    margin: 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(32px, 4vw, 48px);
    font-family: Red Rose-SemiBold;
    text-transform: uppercase;
    line-height: 1.1;
  }

  .attributes-list {
    margin: clamp(24px, 3.5vw, 44px) 0 0;
  }

  .attributes-row {
    display: grid;
    grid-template-columns: minmax(180px, 0.35fr) minmax(0, 0.65fr);
    gap: clamp(16px, 2vw, 28px);
    padding: clamp(14px, 1.5vw, 20px) clamp(12px, 2vw, 28px);
    border-bottom: 1px solid rgba(244, 244, 244, 1);
    background-color: rgba(244, 244, 244, 0.7);

    &:nth-child(even) {
      background-color: #fff;
    }

    dt {
      margin: 0;
      color: rgba(22, 0, 4, 1);
      font-size: clamp(14px, 1.4vw, 22px);
      font-family: PingFang SC-Semibold;
      line-height: 1.5;
      text-transform: uppercase;
    }

    dd {
      margin: 0;
      color: rgba(22, 0, 4, 1);
      font-size: clamp(14px, 1.4vw, 22px);
      font-family: PingFang SC-Regular;
      line-height: 1.6;
    }
  }

  .related-section {
    margin-top: clamp(64px, 8vw, 120px);
    padding-top: clamp(24px, 3vw, 36px);
    border-top: 1px solid rgba(241, 241, 241, 1);
  }

  .related-grid {
    margin-top: clamp(24px, 3vw, 44px);
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: clamp(12px, 1.8vw, 24px);
  }

  .related-expand-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: clamp(48px, 6vw, 80px) auto 0;
    width: min(100%, 350px);
    height: 60px;
    padding: 0 20px;
    border: none;
    border-radius: 4px;
    background-color: rgba(22, 0, 4, 1);
    color: rgba(255, 255, 255, 1);
    font: inherit;
    cursor: pointer;
  }

  .related-expand-toggle__inner {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  .related-expand-toggle__icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    object-fit: contain;
    display: block;

    &--down {
      transform: rotate(180deg);
    }
  }

  .related-expand-toggle__label {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
    font-family: Red Rose-Regular;
    font-weight: normal;
    line-height: 20px;
    white-space: nowrap;
  }

  .related-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    img {
      width: 100%;
      aspect-ratio: 1 / 1;
      object-fit: cover;
      display: block;
    }

    h3 {
      margin: 14px 0 0;
      color: rgba(22, 0, 4, 1);
      font-size: clamp(18px, 1.5vw, 24px);
      font-family: Red Rose-Medium;
      line-height: 1.2;
    }

    button,
    .related-cardLink {
      margin-top: 10px;
      min-height: var(--tap-min);
      padding: 8px 12px;
      border: 1px solid rgba(22, 0, 4, 1);
      border-radius: 4px;
      background-color: transparent;
      color: rgba(22, 0, 4, 1);
      font-size: 14px;
      font-family: Red Rose-Regular;
      text-transform: uppercase;
      cursor: pointer;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media (max-width: 1023px) {
    .product-overview {
      /* minmax(0,1fr) prevents Swiper’s multi-slide min-content width from blowing out the track */
      grid-template-columns: minmax(0, 1fr);
    }

    .product-overview__content {
      width: 100%;
    }

    .product-overview__actions {
      width: min(100%, 460px);
    }

    .attributes-row {
      grid-template-columns: 1fr;
      gap: 6px;
    }

    .related-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 767px) {
    .detail-main {
      width: calc(100% - 2 * var(--container-pad));
      padding-top: 20px;
    }

    .product-overview__actions {
      width: 100%;
    }
  }

  @media (max-width: 375px) {
    .related-grid {
      grid-template-columns: 1fr;
    }
  }
}
